import noop from 'utils/noop';

import type { ILogger } from './types';

//** ONLY use when logging in core files that the logger use to avoid circular deps which breaks tree-shaking */
export const noCircularLogger = (level: keyof ILogger, ctx: any) =>
  import('./index')
    .then(m => m.logger[level]({ ...ctx, message: ctx?.message }))
    .catch(noop);
